<template>
	<header-block :title="'Uncategorised - ' + groupedTransactions.length + ' left'" class="title"></header-block>
	<CustomerLoadWait :customer="(transaction || firstTransaction) && classificationOptions" :cardBlocks="true" :withTopCard="true" />
	
	<BankCardCarousel 
		v-if="groupedTransactions && bankInfo"
		:items="groupedTransactions"
		:formatter="formatter"
		:bankInfo="bankInfo"
		:paginationDots="true"
		:visibleDots="5"
		@transactionSelected="onCarouselTransactionSelected" />

	<div class="bulkTagSelector" v-if="firstTransaction">
		<TransactionTagging :selectAlways="true" :transaction="firstTransaction" :categories="transactionClassifications" :currentSelectionId="selectedClassificationId"
				:suggestedClassification="suggestedClassification"
				@tag="_onTagUpdated" @chosen="_scrollToBottom" />
	</div>
</template>


<script>

import Services from '../mixins/Services';
import SpendingAnalysis, { GRANDPARENT_CLASSIFICATIONS } from '../mixins/SpendingAnalysis';
import Helpers from '../mixins/Helpers';
import Transaction from '../mixins/Transaction';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import TransactionTagging from './elements/TransactionTagging.vue';
import BankCardCarousel from './elements/BankCardCarousel.vue';

export default {
	mixins: [Services, Helpers, SpendingAnalysis, Transaction],
	components: { CustomerLoadWait, HeaderBlock, TransactionTagging, BankCardCarousel },
	data() {
		return {
			classificationOptions: [],
			classifications: [],
			selectedClassificationId: null,
			selectedClassification: null,
			firstTransaction: null,
			selectedTransactionGroup: [],
			fromDate: null,
			toDate: null,
			groupedTransactions: [],
			includeNegative: null, 
			inclidePositive: null,
			bulkClassificationId: null,
			suggestedClassificationReady: false,
			groupSize: null,
			currentGroupIndex: 0,
		}
	},
	computed: {
	},
	methods: {
		onCarouselTransactionSelected(index, transaction) {
			this.currentGroupIndex = index;
			if (transaction) {
				this.onTransactionSelected(transaction);
			} else if (this.groupedTransactions && this.groupedTransactions[index]) {
				this.onTransactionSelected(this.groupedTransactions[index].value[0]);
			}
		},
		onLoad: async function() {
			const queryParams = this.$route.query;
			this.fromDate = queryParams.from || null;
			this.toDate = queryParams.to || null;
			this.includeNegative = queryParams.includeNegative || null;
			this.includePositive = queryParams.includePositive || null;
			this.fetchUncategorizedClassificationsAndTransactions();
		},
		fetchUncategorizedClassificationsAndTransactions() {
			this._getTransactionClassifications((result) => {
				this.bulkClassificationId = this._findClassificationByName('Uncategorized', result).mgClassification.id;
				this.transactionClassifications = result;
				this.classifications = result;
				this.classificationOptions = result.map(c => ({id: c.mgClassification.id, title: c.mgClassification.fullName}));
				this.getTransactions(this.bulkClassificationId);
			});
		},
		getTransactions: function(classificationId){
			this._getTransactions(classificationId, this.fromDate, this.toDate, () => 
			{
				if (this.transactions.transactions.length === 0) {
					this.$router.replace({ path: '/bulktaggingcomplete' });
					return;
				}

				this.suggestedClassificationReady = false;
				this.suggestedClassification = null;
				this._getSuggestedClassification(this.transactions.transactions[0].merchantName, () => {
					this.suggestedClassificationReady = true;
				});

				// TODO REFACTOR THIS I THINK as suggestedClassification is VERY likley to always be null here as the above call is asnyc
				if (!this.suggestedClassification && this.transactions.transactions[0].amount > 0) {
					var incomeClassifications = this._findClassificationsByGrandparentClassification(GRANDPARENT_CLASSIFICATIONS.INCOME, this.transactionClassifications);
					this.suggestedClassification = incomeClassifications[0];
				}
				// remove negative transactions if includeNegative is false
				if (!this.includeNegative) {
					this.transactions.transactions = this.transactions.transactions.filter(t => t.amount > 0);
				}
				// remove positive transactions if includePositive is false
				if (!this.includePositive) {
					this.transactions.transactions = this.transactions.transactions.filter(t => t.amount < 0);
				}
				this.groupTransactionsByMerchantName();
				this.groupedTransactions[0].value[0].selected = true;
				this.transaction = this.groupedTransactions[0].value[0];
				this.firstTransaction = this.groupedTransactions[0].value[0];
				this.selectedTransactionGroup = this.groupedTransactions[0];
				this._getBankingInfo();
			}, /* includeChildren */ false, /* refreshCache */ true);
		},
		// getBankAccountByAccountId: function(id) {
		// 	var bank = this.bankInfo.accounts.find(ba => ba.id === id);
		// 	return bank;
		// },
		groupTransactionsByMerchantName: function() {
			this.groupedTransactions = this.transactions.transactions.reduce((acc, transaction) => {
				const merchantName = transaction.merchantName || 'Unknown';
				if (!acc[merchantName]) {
					acc[merchantName] = [];
				}
				acc[merchantName].push(transaction);
				return acc;
			}, {});

			this.groupedTransactions = Object.entries(this.groupedTransactions)
				.map(([key, value]) => ({ key, value }))
				.sort((a, b) => new Date(b.value[0].timestamp) - new Date(a.value[0].timestamp));
		},
		getClassificationNameByClassiciationId: function(id) {
			const classification = this._findClassificationById(id, this.classifications);
			if (classification) {
				const name = classification.mgClassification.mgSubClassification || classification.mgClassification.fullName;
				return name.length > 15 ? name.substring(0, 10) + '...' : name;
			}
			return null;
		},
		getIconByClassiciationId: function(id) {
			const classification = this._findClassificationById(id, this.classifications, true);
			if (classification) {
				return classification.mgClassification.iconPath;
			}
			return null;
		},
		updateClassification: function(transaction) {
			this.selectedTransactionGroup = this.groupedTransactions.find(g => g.value[0].id === transaction.id);
			if (transaction.alwaysApplyTag || transaction.alwaysApplyExludeInclude) {
				this._createRule(transaction);
			}
			else if (this.selectedTransactionGroup && this.selectedTransactionGroup.value.length > 1) {
				// update a group of transcations
				this.updateGroupTransactions(transaction);
			}
			else {
				// update single transcation
				this._updateSingleTransaction(transaction);
			}

			if (this.groupedTransactions) {
				this.removeTransactionFromGroup(transaction);
				if (this.groupedTransactions.length === 0) {
					this.$router.replace({ path: '/bulktaggingcomplete' });
				}
			}
		},
		removeTransactionFromGroup: function(transaction) {
			this.suggestedClassificationReady = false;
			const index = this.groupedTransactions.findIndex(g => g.value[0].selected === true);
			this.groupedTransactions = this.groupedTransactions.filter(g => g.value[0].id !== transaction.id);
			if (index >= 0 && index < this.groupedTransactions.length) {
				this.groupedTransactions[index].value[0].selected = true;
				this.firstTransaction = this.groupedTransactions[index].value[0];
			} else if (this.groupedTransactions.length > 0) {
				this.groupedTransactions[this.groupedTransactions.length - 1].value[0].selected = true;
				this.firstTransaction = this.groupedTransactions[this.groupedTransactions.length - 1].value[0];
			}

			if (this.groupedTransactions.length > 0) {
				const newLen = this.groupedTransactions.length;
				let nextIndex = index;
				if (nextIndex >= newLen) nextIndex = newLen - 1;
				if (nextIndex < 0) nextIndex = 0;
				this.currentGroupIndex = nextIndex;
				this.suggestedClassification = null;
				this._getSuggestedClassification(this.firstTransaction.merchantName, () => {
					this.suggestedClassificationReady = true;
				});
			}
		},

		updateGroupTransactions: function(transaction) {
			var customerClassification = transaction.customerClassification;
			this.selectedTransactionGroup = this.groupedTransactions.find(g => g.value[0].id === transaction.id);
			this._updateBulkTransactionClassifications(this.selectedTransactionGroup, customerClassification, () => {
				this.refresh();
			});
		},

		refresh: function() {
			this._getTransactions(this.bulkClassificationId, this.fromDate, this.toDate, () => {}, /*refreshCache: */ false, /* clearCache */ true);
			this._getBankAccount(this.transaction.bankAccountID, null, /* lite: */ false, /*refreshCache: */ true); //Force cache refresh of bank transactions to reflect new classification
			this._clearSpendingAnalysis();
			this._clearBankingInfo();
		},

		onTransactionSelected: function(transaction) {
			this.firstTransaction = transaction;
			this.transaction = transaction;
			this.groupedTransactions.forEach(element => {
				element.value[0].selected = false;
			});
			this.selectedTransactionGroup = this.groupedTransactions.find(g => g.value[0].id === transaction.id);
			this.suggestedClassificationReady = false;
			this.suggestedClassification = null;
			this._getSuggestedClassification(this.transaction.merchantName, () => {
				this.suggestedClassificationReady = true;
			});

			transaction.selected = true;
		},
		getTransactionGroupAmount(group) {
			var total = 0;
			// foreach group.value, sum the amount
			group.forEach(t => total += t.amount);
			return total;
		},
		getTransactionCount(group) {
			this.groupSize = group.length;
			return group.length;
		}
	},
	mounted: function () {
		this.onLoad();
	},
	watch: {
		currentGroupIndex(newIndex) {
			if (this.groupedTransactions && this.groupedTransactions[newIndex]) {
				this.onTransactionSelected(this.groupedTransactions[newIndex].value[0]);
			}
		}
	},
}

</script>

<style scoped>


.transactionHeader {
	color: var(--text-color);
	font-size: 20px;
	text-align: center;
	padding-top: 30px;
	font-weight: bold;
	p{
		font-size: 20px;
		font-family: 'Gotham-Heavy';
		margin-top: 0px;
	};
	.small {
		font-size: 10px;
		margin-top: -40px;
	}
}

.title {
	font-size: 14px;
}

.bulkTagSelector {
	margin-right: -30px;
	margin-left: -30px;
	padding: 20px;
	padding-top: 5px;
	overflow-y: scroll;
}
</style>
